import { Button, Menu, theme as defaultTheme } from "@mindlercare/ui-web";
import { styled } from "styled-components";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`;

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: ${defaultTheme.SPACING.MD};
  gap: ${defaultTheme.SPACING.SM};
`;

const SelectedTemplateButton = styled(Button)`
  border: none;
  height: unset;
  padding: ${defaultTheme.SPACING.SM} ${defaultTheme.SPACING.MD};
  position: relative;
  background-color: ${defaultTheme.COLORS.GRAY_LIGHT};
  font-size: ${defaultTheme.FONT.SIZE.SMALL_MEDIUM};

  span {
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  overflow: hidden;
`;

const StyledMenuTrigger = styled(Menu.Trigger)`
  display: flex;
  align-items: center;
  gap: ${defaultTheme.SPACING.SM};

  svg {
    flex-shrink: 0;
  }
`;

const MenuGroup = styled.div`
  & li {
    padding-left: ${defaultTheme.SPACING.LG};
  }
`;

const CategoryTitle = styled.div`
  padding: ${defaultTheme.SPACING.SM} ${defaultTheme.SPACING.MD};
  cursor: default;
`;

const MenuItem = styled.div<{ selected?: boolean }>`
  font-size: ${defaultTheme.FONT.SIZE.SMALL_MEDIUM};
  font-weight: ${({ selected }) =>
    selected
      ? defaultTheme.FONT.WEIGHT.BOLD
      : defaultTheme.FONT.WEIGHT.REGULAR};
`;

const Divider = styled.div`
  margin: 16px 10px 0px 10px;
  border-top: 1px solid ${defaultTheme.COLORS.GREY};
`;

const TemplateArea = styled.div`
  box-shadow: 0px 2px 8px 0px #13302833;
  position: absolute;
  top: 44px;
  right: 0;
  background: white;
  min-width: 202px;
  z-index: 6;
`;

const TemplateItemBg = styled.div`
  padding: 8px 16px;
  cursor: pointer;
  &:hover {
    background-color: ${defaultTheme.COLORS.GRAY_X_LIGHT};
  }
`;

const TemplateItem = styled.div<{ selected?: boolean }>`
  font-size: ${defaultTheme.FONT.SIZE.SMALL_MEDIUM};
  line-height: 20px;
  font-weight: ${({ selected }) =>
    selected
      ? defaultTheme.FONT.WEIGHT.BOLD
      : defaultTheme.FONT.WEIGHT.REGULAR};
`;

export {
  Container,
  ButtonContainer,
  SelectedTemplateButton,
  StyledMenuTrigger,
  MenuGroup,
  CategoryTitle,
  MenuItem,
  Divider,
  TemplateArea,
  TemplateItemBg,
  TemplateItem,
};
